import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import api from '../../lib/api';
import styles from './Affiliate.module.css';

const AffiliateRegister: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    try {
      await api.post('/affiliates/register', { email, name, password });
      setSuccess(true);
      setTimeout(() => {
        navigate('/affiliate/login');
      }, 2000);
    } catch (err: any) {
      setError(
        err?.response?.data?.error || 'Registration failed'
      );
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className={styles.loginPage}>
      <div className={styles.loginCard}>
        <div className={styles.logo}>
          OFMIG<span>.SHOP</span>
        </div>
          <p className={styles.title}>Registration Successful!</p>
          <p style={{ textAlign: 'center', marginTop: '1rem' }}>
            Redirecting to login...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.loginPage}>
      <form className={styles.loginCard} onSubmit={handleSubmit}>
        <div className={styles.logo}>
          OFMIG<span>.SHOP</span>
        </div>
        <p className={styles.title}>Affiliate Registration</p>

        <div className={styles.formGroup}>
          <label>Full Name</label>
          <input
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="John Doe"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Email</label>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Password</label>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Confirm Password</label>
          <input
            type="password"
            className={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={loading}
        >
          <FiUsers size={16} />
          {loading ? 'Creating...' : 'Create Account'}
        </button>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.linkText}>
          Already have an account? <Link to="/affiliate/login">Login here</Link>
        </div>
      </form>
    </div>
  );
};

export default AffiliateRegister;
